// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_27-6";
export var headerCell = "_27-2";
export var rowWrapper = "_27-4";
export var stickyAggregationCell = "_27-a";
export var stickyAggregationRow = "_27-7";
export var stickyColumnCell = "_27-9";
export var stickyColumnHeaderCell = "_27-8";
export var table = "_27-1";
export var virtualRowWrapper = "_27-5";
export var virtualTableContainer = "_27-0";
export var white = "_27-3";